import React, {Component} from 'react'
import {Modal, ModalBody} from 'reactstrap';
import SaleCardView from "../../components/sale/SaleCardView";
import SaleDetailView from "../../components/sale/SaleDetailView";
import {DragDropContext, Droppable, Draggable } from "react-beautiful-dnd"

const arraySort = require('array-sort');

var stateManager = require('../../utils/state/stateManager.js');
var stringUtil = require('../../utils/string/stringUtil');
var salesStatusUtil = require('../../utils/domain/sales/salesStatusUtil');
var salesLoader = require('../../utils/domain/sales/salesLoader');
var saleCommonUtility = require('../../utils/domain/sales/saleCommonUtility');
var logger = require('../../utils/logger/logger');
var dateUtil = require('../../utils/dateUtil/dateUtil');
var translator = require('../../utils/translator/translator');
var constants = require('../../utils/domain/constants');

const inProcessSalesDroppableId = "InProcess.Sales.Droppable"
const pendingSalesDroppableId = "Pending.Sales.Droppable"
const readySalesDroppableId = "Ready.Sales.Droppable"
class KitchenOverview extends Component 
{
    constructor(props)
    {
        super(props);

        this.state = {};
        this.state.selectedSale = null;

        this.onDragEnd = this.onDragEnd.bind(this);
    }

    render()
    {
        let inProcessSalesComponents = this.renderInProcessSales();
        let pendingSalesComponents = this.renderPendingSales();
        let readySalesComponents = this.renderReadySales();

        let maximumComponentCount = inProcessSalesComponents.length + pendingSalesComponents.length;
        maximumComponentCount = maximumComponentCount + 5;
        let readyHolderHeight = maximumComponentCount * 15;
        
        return  <DragDropContext key="ModifierDragAndDropContext" onDragEnd={this.onDragEnd}>
                    <div className='h-100'>
                        <table style={{width:'100%', height:'100%'}}>
                                <tr>
                                    <td style={{width:'50%', background:'var(--colors-primary)', color:'white', textAlign:'center',}}>
                                        <div style={{fontSize:'1.1rem', marginTop:'5px', marginBottom:'5px'}}>{translator.getLabel("kitchen_status_in_process")}</div>
                                    </td>
                                    <td style={{width:'50%', background:'var(--colors-success)', color:'white', textAlign:'center'}}>
                                        <div style={{fontSize:'1.1rem', marginTop:'5px', marginBottom:'5px'}}>{translator.getLabel("kitchen_status_ready")}</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{borderRight:'1px solid var(--colors-primary)', marginRight:'5px', verticalAlign:'top'}}>
                                        <div style={{marginLeft:'5px', marginRight:'10px', 
                                                    paddingTop:'10px', paddingBottom:'10px'}}>

                                            <Droppable droppableId={inProcessSalesDroppableId}>
                                                {(provided, snapshot) => (
                                                                            <div ref={provided.innerRef}>
                                                                                {inProcessSalesComponents}
                                                                                {provided.placeholder && <div style={{minHeight:'40vh'}}/>}
                                                                            </div>
                                                                        )}
                                            </Droppable>
                                        </div>

                                        <div style={{borderTop: '1px solid var(--colors-primary)',
                                                     borderBottom: '1px solid var(--colors-primary)',
                                                     color: 'var(--colors-primary)',
                                                     paddingTop:'10px', paddingBottom:'10px',
                                                     marginTop:'0px', 
                                                     marginLeft:'10px', marginRight:'15px',
                                                     textAlign:'center'}}>

                                            {translator.getLabel("kitchen_status_pending")}

                                        </div>

                                        <div style={{marginLeft:'5px', marginRight:'10px', 
                                                    paddingTop:'10px', paddingBottom:'10px'}}>

                                            <Droppable droppableId={pendingSalesDroppableId}>
                                                {(provided, snapshot) => (
                                                                            <div ref={provided.innerRef}>
                                                                                {pendingSalesComponents}
                                                                                {provided.placeholder && <div style={{minHeight:'25vh'}}/>}
                                                                            </div>
                                                                        )}
                                            </Droppable>
                                        </div>

                                    </td>
                                    <td style={{verticalAlign:'top'}}>
                                        <div style={{marginLeft:'5px', marginRight:'5px'}}>
                                            <div style={{marginLeft:'5px', marginRight:'5px', 
                                                    paddingTop:'10px', paddingBottom:'10px',   
                                                    minHeight:'80vh'}}>

                                                <Droppable droppableId={readySalesDroppableId}>
                                                    {(provided, snapshot) => (
                                                                                <div ref={provided.innerRef}>
                                                                                    {readySalesComponents}
                                                                                    {provided.placeholder && <div style={{minHeight:`${readyHolderHeight}vh`}}/>}
                                                                                </div>
                                                                            )}
                                                </Droppable>
                                            
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                        </table>
                        {this.renderSaleDetailModalDialogue()}
                    </div>
                </DragDropContext>
    }

    renderInProcessSales()
    {
        let components = [];
        let sales = this.getInProcessSales()
        for (var index = 0; index < sales.length; index++)
        {
            let sale = sales[index];
            components.push(<Draggable key={sale.id} draggableId={sale.id} index={index}>
                                {(provided, snapshot) => (
                                    <div ref={provided.innerRef} {...provided.draggableProps}{...provided.dragHandleProps}>
                                        <div onClick={()=>
                                                {
                                                    this.state.selectedSale = sale;
                                                    this.setState({});
                                                }}>
                                            <SaleCardView sale={sale}/>
                                        </div>
                                    </div>
                                )}
                            </Draggable>);
        }
        return components
    }

    renderPendingSales()
    {
        let components = [];
        let sales = this.getPendingSales()
        for (var index = 0; index < sales.length; index++)
        {
            let sale = sales[index];
            components.push(<Draggable key={sale.id} draggableId={sale.id} index={index}>
                                {(provided, snapshot) => (
                                    <div ref={provided.innerRef} {...provided.draggableProps}{...provided.dragHandleProps}>
                                        <div onClick={()=>
                                                {
                                                    this.state.selectedSale = sale;
                                                    this.setState({});
                                                }}>
                                            <SaleCardView sale={sale}/>
                                        </div>
                                    </div>
                                )}
                            </Draggable>);
        }
        return components
    }

    renderReadySales()
    {
        let sales = this.getReadySales()
        let components = [];

        for (var index = 0; index < sales.length; index++)
        {
            let sale = sales[index];
            components.push(<Draggable key={sale.id} draggableId={sale.id} index={index}>
                                {(provided, snapshot) => (
                                    <div ref={provided.innerRef} {...provided.draggableProps}{...provided.dragHandleProps}>
                                        <div onClick={()=>
                                                {
                                                    this.state.selectedSale = sale;
                                                    this.setState({});
                                                }}>
                                            <SaleCardView sale={sale}/>
                                        </div>
                                    </div>
                                )}
                            </Draggable>);
        }
        return components
    }

    getInProcessSales()
    {
        let sales = stateManager.getStore().getState().todaySales;
        sales = sales.filter(sale => !saleCommonUtility.isCancelled(sale) && 
                                     sale.saleType != constants.SaleTypeHold &&
                                     !salesStatusUtil.isSalePendingDueToTime(sale) && 
                                     !salesStatusUtil.isSaleCompletedByAnyFinalStation(sale.id))
        
        return arraySort(sales, ["dueDateTime", "dateTime"]);
    }

    getPendingSales()
    {
        let sales = stateManager.getStore().getState().todaySales;
        sales = sales.filter(sale => !saleCommonUtility.isCancelled(sale) && 
                                     sale.saleType != constants.SaleTypeHold &&
                                     salesStatusUtil.isSalePendingDueToTime(sale) && 
                                     !salesStatusUtil.isSaleCompletedByAnyFinalStation(sale.id))
        
        return arraySort(sales, ["dueDateTime", "dateTime"]);
    }

    getReadySales()
    {
        
        let sales = stateManager.getStore().getState().todaySales;
        
        sales = sales.filter(sale => !saleCommonUtility.isCancelled(sale) && 
                                     sale.saleType != constants.SaleTypeHold &&
                                     salesStatusUtil.isSaleCompletedByAnyFinalStation(sale.id) && 
                                     !salesStatusUtil.isSaleCompletedByDispatchStation(sale.id))
        
        return arraySort(sales, ["dueDateTime", "dateTime"]);
    }

    renderSaleDetailModalDialogue()
    {
        if (this.state.selectedSale == null)
            return;

        return(<Modal isOpen={true} centered animation={false} fade={false} style={{minWidth:'35vw', maxWidth:'35vw'}}
                        toggle={()=>
                                {
                                    this.state.selectedSale = null;
                                    this.setState({});
                                }} >
                    <ModalBody>
                        <div>
                            <div style={{height:'80vh', overflowY:'auto'}}>
                                <SaleDetailView sale={this.state.selectedSale}
                                                onDispatch={()=>
                                                {
                                                    this.state.selectedSale = null;
                                                    this.setState({});
                                                }}/>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>);
    }

    onDragEnd(result)
    {
        try
        {
            if (stringUtil.isStringNullOrEmpty(result.draggableId) || 
                result.source == null || 
                stringUtil.isStringNullOrEmpty(result.source.droppableId) ||
                stringUtil.isStringNullOrEmpty(result.source.index) || 
                result.destination == null || 
                stringUtil.isStringNullOrEmpty(result.destination.droppableId) == null ||
                result.source.droppableId == readySalesDroppableId
                )
                return;
    
            let inProcessSales = this.getInProcessSales();
            let pendingSales = this.getPendingSales();

            if ( (result.source.droppableId == inProcessSalesDroppableId || result.source.droppableId == pendingSalesDroppableId) 
                && result.destination.droppableId == readySalesDroppableId)
            {
                let sales = result.source.droppableId == inProcessSalesDroppableId ? inProcessSales : pendingSales;
                let sale = sales.find(s => stringUtil.areStringSame(s.id, result.draggableId));
                if (sale == null) return;

                salesStatusUtil.markSaleStatusAsCompletedByFinalStation(sale);
            }
    
            if (result.source.droppableId == pendingSalesDroppableId && result.destination.droppableId == inProcessSalesDroppableId)
            {
                let inProcessSales = this.getInProcessSales();
                let pendingSales = this.getPendingSales();

                let sourceIndex = result.source.index;
                let sourceSale = pendingSales[sourceIndex];

                if (result.destination.index >= inProcessSales.length)
                {
                    let activationThresholdInMinutes = salesStatusUtil.getOrderActivationThresholdInMinutes(sourceSale);
                    sourceSale.dueDateTime = dateUtil.addMinutes(dateUtil.getNow(), activationThresholdInMinutes-5);
                    salesLoader.initializeSaleActivationDateTime(sourceSale);
                }
                else
                {
                    let destinationIndex = result.destination.index;
                    let referenceSale = inProcessSales[destinationIndex];

                    sourceSale.dueDateTime = dateUtil.addSeconds(referenceSale.dueDateTime, -1);
                    sourceSale.activationDateTime = dateUtil.addSeconds(referenceSale.activationDateTime, -1);
                }

                salesStatusUtil.updateDueTime(sourceSale.id, sourceSale.dueDateTime);
                salesStatusUtil.updateActivationTime(sourceSale.id, sourceSale.activationDateTime);
            }
    
            if (result.source.droppableId == inProcessSalesDroppableId && result.destination.droppableId == pendingSalesDroppableId)
            {
                let inProcessSales = this.getInProcessSales();
                let pendingSales = this.getPendingSales();

                let sourceIndex = result.source.index;
                let sourceSale = inProcessSales[sourceIndex];

                if (result.destination.index >= pendingSales.length)
                {
                    let activationThresholdInMinutes = salesStatusUtil.getOrderActivationThresholdInMinutes(sourceSale);
                    let activationTargetDateTime = dateUtil.addMinutes(dateUtil.getNow(), activationThresholdInMinutes);
                    let differenceInMinutes = dateUtil.differenceInMinutes(activationTargetDateTime, sourceSale.dueDateTime);
                    
                    sourceSale.dueDateTime = dateUtil.addMinutes(sourceSale.dueDateTime, differenceInMinutes+5);
                    salesLoader.initializeSaleActivationDateTime(sourceSale);
                }
                else
                {
                    let destinationIndex = result.destination.index;
                    let referenceSale = pendingSales[destinationIndex];

                    sourceSale.dueDateTime = dateUtil.addSeconds(referenceSale.dueDateTime, -1);
                    sourceSale.activationDateTime = dateUtil.addSeconds(referenceSale.activationDateTime, -1);
                }

                salesStatusUtil.updateDueTime(sourceSale.id, sourceSale.dueDateTime);
                salesStatusUtil.updateActivationTime(sourceSale.id, sourceSale.activationDateTime);
            }
    
            
    
            if ( 
                 (result.source.droppableId == inProcessSalesDroppableId && result.destination.droppableId == inProcessSalesDroppableId) ||
                 (result.source.droppableId == pendingSalesDroppableId && result.destination.droppableId == pendingSalesDroppableId)
               )
            {
                if (stringUtil.isStringNullOrEmpty(result.destination.index))
                    return;

                if (result.source.droppableId == result.destination.droppableId && result.source.index == result.destination.index)
                    return;
    
                
                let sales = result.source.droppableId == inProcessSalesDroppableId ? this.getInProcessSales() : this.getPendingSales();
                let sourceIndex = result.source.index;
                let destinationIndex = result.destination.index;

                let sourceSale = sales[sourceIndex];
                let referenceSale = sales[destinationIndex];
                
                sourceSale.dueDateTime = dateUtil.addSeconds(referenceSale.dueDateTime, -1);
                sourceSale.activationDateTime = dateUtil.addSeconds(referenceSale.activationDateTime, -1);

                salesStatusUtil.updateDueTime(sourceSale.id, sourceSale.dueDateTime);
                salesStatusUtil.updateActivationTime(sourceSale.id, sourceSale.activationDateTime);
    
            }
        }
        catch(error)
        {
            logger.error(`${translator.getLabel("error_occurred_while_dragging_sale_in_kitchen_view")}: ${error}`, {}, error);
        }
    }
}

export default KitchenOverview;